import { ExchangeOptionFilter } from './involuntary-change.model';
import { Segment } from './itinerary.model';
import { ExchangeAvailabilityOption } from './voluntary-change.model';

export class ExchangeModuleFilter {
  availabilities: ExchangeAvailabilityOption[];
  filter: ExchangeOptionFilter;

  constructor(availabilities: ExchangeAvailabilityOption[], filter: ExchangeOptionFilter) {
    this.availabilities = availabilities;
    this.filter = filter;

  }

  private stops(segments: Segment[]): number[] {
    return segments.reduce((res, segment) => 
       res.concat(segment.flights.length - 1)
    , []);
  }
  
  private airlines (segments: Segment[]): string[]  {
    return segments.reduce((res, segment) =>
       segment.flights.reduce((result, flight) => result.concat(this.transformToLowerCase(flight.operatingCarrier.code)), []).concat(res)
    , []);
  };
  
  private classes(segments: Segment[]): string[]  {
    return segments.reduce((res, segment) =>
       segment.flights.reduce((result, flight) => result.concat(this.transformToLowerCase(flight.classOfService)), []).concat(res)
    , []);
  };
  
  private fareFamilies(segments: Segment[]): string[]  {
    return segments.reduce((res, segment) =>
       segment.flights.reduce((result, flight) => result.concat(this.transformToLowerCase(flight.fareFamily)), []).concat(res)
    , []);
  };

  private  transformToLowerCase (value: string): string  {
      return !!value ? value.toLowerCase() : '';
    };
    
  private departureFirstFlightTime(segments: Segment[], filterDate: string): boolean  {
    return segments.length > 0  ? (this.transformToLowerCase(segments[0].departureDate) === filterDate) : false;
  };
    
  filterAvailabilityOptions  (): ExchangeAvailabilityOption[]  {
    return this.availabilities.filter((option: ExchangeAvailabilityOption)=> {
  
        const res1 = this.filter.stops >= 0 ? this.stops(option.segments).includes(this.filter.stops) : true ;
        const res2 = this.filter.airline.length > 0 ? this.airlines(option.segments).includes(this.filter.airline) : true;
        const res3 = this.filter.class.length > 0 ? this.classes(option.segments).includes(this.filter.class) : true ;
        const res4 = this.filter.fareFamily.length > 0 ? this.fareFamilies(option.segments).includes(this.filter.fareFamily) : true;
        const res5 = this.filter.time ? this.departureFirstFlightTime(option.segments, this.filter.time) : true;
        return res1 && res2 && res3 && res4 && res5;
        }
      );
  };


}